<template>
    <div v-if="pageView === 'material'" style="width: 100%; height: 100%">
        <searchHallMaterialComponent :keyword="keyword" :viewList="viewList" :viewName="'material'" @changeView="changeView" @go-shop="goShop"/>
    </div>

    <div v-if="pageView === 'shop'" style="width: 100%; height: 100%">
        <searchHallShopComponent :keyword="keyword" :viewList="viewList" :viewName="'shop'" @changeView="changeView" @go-shop="goShop"/>
    </div>

    <div v-if="pageView === 'total'" style="width: 100%; height: 100%">
        <searchHallTotalComponent :keyword="keyword" :viewList="viewList" :viewName="'total'" @changeView="changeView" @go-shop="goShop"/>
    </div>

</template>

<script setup>
    import {getCurrentInstance, inject, onMounted, ref} from 'vue'
    import searchHallMaterialComponent from '@/components/phone/hall/searchHallMaterialComponent.vue'
    import searchHallShopComponent from '@/components/phone/hall/searchHallShopComponent.vue'
    import searchHallTotalComponent from '@/components/phone/hall/searchHallTotalComponent.vue'

    // const props = defineProps(['materialObj'])
    const emits = defineEmits(['go-shop'])

    const i18n = inject("i18n")

    const pageView = ref("total")
    const keyword = ref("")
    const viewList = ref([
        // {
        //     key: i18n.tkey("lang_all"),
        //     value: "total"
        // },
        {
            key: i18n.tkey("lang_item_1"),
            value: "material"
        },
        {
            key: i18n.tkey("lang_merchant"),
            value: "shop"
        },
        {
            key: i18n.tkey("lang_memberwork"),
            value: "card"
        }
    ])

    function changeView(str, key) {
        pageView.value = str
        keyword.value = key
    }

    function goShop(wa, siojournal) {
        emits("go-shop", wa, siojournal)
    }

    // onMounted(() => {
    //
    // })
</script>

<style scoped>

</style>